














































import { Component, Mixins } from 'vue-property-decorator';
import { Actions, Mutations, TrackingActions } from '@/ts/store/Constants';
import DeviceMethods from '@/mixins/DeviceMethods.vue';
import BackButton from '@/components/Buttons/BackButton.vue';
import LocalizationMethods from '@/mixins/LocalizationMethods.vue';
import UserInquiryType from '@/ts/UserInquiryType';
import UserInquiryCategory from '@/ts/UserInquiryCategory';
import UserInquiry from '@/ts/UserInquiry';
import UserInquiryAnswer from '@/ts/UserInquiryAnswer';
import AddNewTicketForm from '@/components/User/Panels/AddNewTicketForm.vue';
import CreateNewTicket from '@/components/Overlays/TicketSystem/CreateNewTicket.vue';

@Component({
    components: {
        BackButton,
        AddNewTicketForm,
        CreateNewTicket,
    },
})
export default class AddNewTicketAnswer extends Mixins(DeviceMethods, LocalizationMethods) {
    constructor() {
        super();
    }

    get activeType(): UserInquiryType  {
        return this.$store.getters['HomeAssistant/getActiveType'];
    }

    get activeCategory(): UserInquiryCategory  {
        return this.$store.getters['HomeAssistant/getActiveCategory'];
    }

    get activeInquiry(): UserInquiry  {
        return this.$store.getters['HomeAssistant/getActiveInquiry'];
    }

    get answers(): UserInquiryAnswer {
        return this.$store.getters['UserTicketsAttributes/getInquiryAnswer'];
    }

    get formOverlayVisibility(): boolean {
        return this.$store.getters['UserTickets/getTicketCreateFormVisibility'];
    }

    public openNewTicketForm() {
        this.$store.commit(Mutations.SET_TICKET_CREATE_FORM_OVERLAY_VISIBILITY, true);
    }

    public close() {
        this.$store.commit(Mutations.SET_ADD_NEW_TICKET_ANSWER_VISIBILITY, false);
        this.$store.commit(Mutations.SET_ADD_NEW_TICKET_THANKS_VISIBILITY, true);
    }

    public back() {
        this.$store.dispatch(Actions.TRACK_ACTION, { action: TrackingActions.Ticket.LEFT_SUBJECT, data: this.activeInquiry.key });

        this.$store.commit(Mutations.SET_ADD_NEW_TICKET_ANSWER_VISIBILITY, false);
        this.$store.commit(Mutations.SET_TICKET_CREATE_FORM_OVERLAY_VISIBILITY, false);
        this.$store.commit(Mutations.SET_ACTIVE_HOME_ASSISTANT_INQUIRY, null);
        this.$store.commit(Mutations.RESET_INQUIRY_ANSWER);
    }

    public created() {
        this.$store.dispatch(Actions.FETCH_INQUIRY_ANSWER, this.activeInquiry.id);
    }

    public mounted() {
        this.$store.dispatch(Actions.TRACK_ACTION, { action: TrackingActions.Ticket.VIEWED_SUBJECT, data: this.activeInquiry.key });
    }
}
